// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sf__part-recommendations .sf__results__result:nth-child(n+5){display:none}", "",{"version":3,"sources":["webpack://./src/js/components/ResultsList.vue"],"names":[],"mappings":"AACI,8DACI,YAAR","sourcesContent":["\n    .sf__part-recommendations .sf__results__result:nth-child(n+5) {\n        display: none;\n    }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
